
/**
 * Url connection enum
 * @author Starley Cazorla
 */
export enum UrlConnectionEnum {
    // Login
    LOGIN = 'proxy/hotsite/v1/usuario/login',
    RESET_PWD = 'proxy/hotsite/v1/usuario/resgatarsenha',
    UPDATE_DEVICE_ID = 'proxy/hotsite/v1/deviceid/atualiza',

    // Profile
    GET_PROFILE = 'auth/hotsite/v1/usuario/consulta',
    UPDATE_PROFILE_PWD = 'auth/hotsite/v1/usuario/altera_senha',
    UPDATE_PROFILE = 'auth/hotsite/v1/usuario/altera_dados',
    DELETE_PROFILE = 'auth/hotsite/v1/usuario/excluir',

    // Address
    GET_ADDRESSES = 'auth/hotsite/v1/endereco/consulta',
    ADD_ADDRESS = 'auth/hotsite/v1/endereco/incluir',
    UPDATE_ADDRESS = 'auth/hotsite/v1/endereco/editar',
    DELETE_ADDRESS = 'auth/hotsite/v1/endereco/excluir',

    UPDATE_STATUS_DOC = 'auth/hotsite/v1/usuario/validando_documentacao',

    // Onboard
    POST_ONBOARDING = 'auth/hotsite/v1/usuario/navegacao',

    // Posts
    GET_ALL_POSTS = 'auth/hotsite/v1/posts/veiculacao',
    LIKE_A_POST = 'auth/hotsite/v1/posts/curtir',
    SEND_NEW_COMMENT = 'auth/hotsite/v1/posts/comentario',
    GET_ALL_POST_COMMENTS = 'auth/hotsite/v1/posts/comentarios',

    // Banners
    GET_ALL_BANNERS = 'auth/hotsite/v1/banners/veiculacao',

    GET_QUALITY_LIST = 'auth/hotsite/v1/qualidade/lista',
    GET_ACTIVATION_LIST = 'auth/hotsite/v1/ativacoes/lista',
    GET_RESCUE_LIST = 'auth/hotsite/v1/resgates/lista',

    GET_ACTIVATION_PRE = 'auth/hotsite/v1/pre/lista',
    SEND_ACTIVATION_PRE = 'auth/hotsite/v1/pre/grava',

    GET_EXTRACT_LIST_TCOINS = 'auth/hotsite/v1/extrato/lista',
    GET_EXTRACT_LIST_TICKET = 'auth/hotsite/v1/extrato/tickets',
    GET_EXTRACT_TOTAL = 'auth/hotsite/v1/extrato/totais',

    ACCEPT_REGULATION = 'auth/hotsite/v1/usuario/optin',

    // Multi Awards
    GET_PRODUCTS_MULTI_AWARDS = 'auth/hotsite/v1/premios/consulta',
    GET_AUCTIONS_MULTI_AWARDS = 'auth/hotsite/v1/leiloes/consulta',
    SEND_RESCUE_MULTI_AWARDS = 'auth/hotsite/v1/premios/resgate',
    SEND_BID_MULTI_AWARDS = 'auth/hotsite/v1/leilao/lance',

    // Help
    GET_LIST_TICKET = 'auth/hotsite/v1/chamados/lista',
    GET_LIST_INTERACTIONS = 'auth/hotsite/v1/chamados/detalhe',
    SEND_RECORD_TICKET = 'auth/hotsite/v1/chamados/gravar',
    SEND_RECORD_INTERACTION = 'auth/hotsite/v1/chamados/interacao',
    SEND_RECORD_EVALUATION = 'auth/hotsite/v1/chamados/avaliacao',

    // Information
    GET_TRAINING_LIST = 'auth/hotsite/v1/treinamentos/lista',
    GET_TRAINING_DETAIL = 'auth/hotsite/v1/treinamento/detalhe',

    // Quiz
    GET_LIST_QUESTION_QUIZ = 'auth/hotsite/v1/quiz/perguntas',
    SEND_QUIZ = 'auth/hotsite/v1/quiz/grava',
    GET_LIST_QUESTION_QUIZ_NEW = 'proxy/hotsite/v1/quiz/perguntasrespostas',
    SEND_QUIZ_NEW = 'auth/hotsite/v3/quiz/grava',
    GET_LIST_ANSERWS_QUIZ = 'auth/hotsite/v1/quiz/respostas',
    GET_OPTION_QUIZ = 'auth/hotsite/v1/quiz/opcoes',
    GET_QUIZ = 'auth/hotsite/v1/quiz/detalhe',
    GET_PLAN_LIST = 'auth/hotsite/v2/planos/lista',

    GET_NEW_LIST_QUIZ = 'auth/hotsite/v1/quiz/desafios',
    POST_STATUS_READ_CHALLENGE = 'proxy/hotsite/v1/usuario/navegacaodesafio',

    // Store
    CREATE_NEW_PARTICIPANT = 'auth/cloudloyalty/v1/participante/criar',
    GET_STORE_PRODUCTS = 'auth/cloudloyalty/v1/vitrine/obter',
    GET_STORE_VITRINE = 'auth/hotsite/v1/vitrine/home',
    SEARCH_STORE_PRICE = 'auth/cloudloyalty/v1/produto/preco',
    GET_STORE_CATEGORIES = 'auth/cloudloyalty/v1/categorias/listar',

    // Store Product
    GET_STORE_PRODUCT_DETAILS = 'auth/cloudloyalty/v1/produto/detalhe',
    GET_LIST_PROCUTCTS = 'auth/cloudloyalty/v2/produtos/buscar',
    STORE_FRETE_SIMULATE = 'auth/cloudloyalty/v1/frete/simulacao',
    STORE_CHECKOUT = 'auth/cloudloyalty/v1/carrinho/incluir',

    // Store Phone Recharge
    GET_STORE_PHONE_RECHARGE_CARRIERS = 'auth/cloudloyalty/v1/recarga/operadoras',
    GET_STORE_PHONE_RECHARGE_AREA_CODE = 'auth/cloudloyalty/v1/recarga/ddds',
    GET_STORE_PHONE_RECHARGE_VALUES = 'auth/cloudloyalty/v1/recarga/valores',
    SEND_STORE_PHONE_RECHARGE = 'auth/cloudloyalty/v1/recarga/resgate',

    // Store pay the bills
    GET_LIST_PARTNER_PAYMENT = 'auth/cloudloyalty/v1/pagamentos/parceiros',
    GET_ACCOUNT_TYPE_PAYMENT = 'auth/cloudloyalty/v1/pagamentos/tipos',
    CHECK_VALID_PAYMENT_BILL = 'auth/cloudloyalty/v1/pagamentos/valida',
    SEND_PAYMENT_BILL = 'auth/cloudloyalty/v1/pagamentos/resgate',

    // Store fuel
    GET_STORE_FUEL_PACKS = 'auth/cloudloyalty/v1/shellbox/packages',
    SEND_RESCUE_FUEL = 'auth/cloudloyalty/v1/shellbox/resgate',

    // Store checkout product
    GET_STORE_CART = 'auth/cloudloyalty/v1/carrinho/obter',
    UPDATE_ITEM_STORE_CART = 'auth/cloudloyalty/v1/carrinho/alterar',
    REMOVE_ITEM_STORE_CART = 'auth/cloudloyalty/v1/carrinho/excluir',
    SAVE_STORE_CART_ADDRESS = 'auth/cloudloyalty/v1/carrinho/endereco',
    SAVE_STORE_CHECKOUT_CART = 'auth/cloudloyalty/v1/compra/incluir',
    SOTRE_CALCULATE_SHIPPING = 'auth/cloudloyalty/v1/carrinho/frete',

    // Sign-up
    SIGN_UP_CHECK_USER = 'proxy/hotsite/v1/usuario/consulta',
    PRE_SIGN_UP = 'proxy/hotsite/v2/usuario/precadastro',
    SIGN_UP_FIRST_ACESS = 'proxy/hotsite/v1/usuario/primeiroacesso',

    // Wallet
    GET_WALLET_STORES = 'auth/hotsite/v1/carteira/lojas',
    GET_WALLET = 'auth/hotsite/v1/carteira/vendas',
    GET_WALLET_VENDOR = 'v1/hotsite/lista-carteira/vendedores',
    GET_WALLET_RESULTS = 'v1/hotsite/lista-resultados',

    // Challenges
    GET_CHALLENGES_LIST = 'auth/hotsite/v2/desafios/lista',
    GET_NEW_CHALLENGES_LIST = 'proxy/hotsite/v3/desafios/lista',

    // Multiluck --- slug de acordo com o jogo (dado esperado: rifa, presente, raspadinha)
    GET_LIST_GAMES_BY_SLUG = 'auth/hotsite/v1/games/lista', // Get List Games by Slug
    GET_NUMBER_OF_RAFFLE = 'auth/hotsite/v1/rifa/numeros', // Rifa
    RESCUE_NUMBER_RAFFLE = 'auth/hotsite/v1/rifa/resgate', // Rifa
    RESCUE_GIFT_BOX = 'auth/hotsite/v1/presente/resgate', // Presente
    RESCUE_SCRATCH_OFF = 'auth/hotsite/v1/raspadinha/resgate', // Raspadinha
    SAVE_RESCUE_GIFT_BOX = 'auth/hotsite/v1/games/gravaresgate',

    //Team
    GET_TEAM_LIST = 'auth/hotsite/v1/lista/equipes',


    FAC_LIST = 'proxy/hotsite/v1/faq/lista',
}
